const ACKO_LOGO_URL = "https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg"
export default ACKO_LOGO_URL